import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
// @ts-ignore
import { FaHospital, FaGift, FaMoneyBillWave, FaLink } from "react-icons/fa";

interface LVCModalProps {
  showModalLVC: boolean;
  setShowModalLVC: (show: boolean) => void;
}

const LVCModal: React.FC<LVCModalProps> = ({ showModalLVC, setShowModalLVC }) => {
  const navigate = useNavigate();

    // ✅ Show modal only on first visit
  // useEffect(() => {
  //   const hasSeenModal = localStorage.getItem("lvcShown");
  //   if (!hasSeenModal) {
  //     setTimeout(() => setShowModalLVC(true), 1500); // Small delay for smooth intro
  //     localStorage.setItem("lvcShown", "true");
  //   }
  // }, []);
  
  return (
    <AnimatePresence>
      {showModalLVC && (
        <motion.div
          className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4 overflow-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
            className="relative bg-white text-green-900 rounded-3xl shadow-2xl max-w-3xl w-full p-8 max-h-[90vh] overflow-auto"
          >
            {/* Close Button */}
            <button
              onClick={() => setShowModalLVC(false)}
              className="absolute top-4 right-4 text-green-800 hover:text-green-600 text-2xl"
            >
              ✕
            </button>

            {/* Title */}
            <h2 className="text-3xl font-extrabold text-center mb-6 text-yellow-500">
              💎 Loven Coin (LVC)
            </h2>

            {/* Intro Text */}
            <p className="text-center text-green-700 mb-6 leading-relaxed">
              <strong>LVC</strong> (Loven Coin) est le token officiel de l’écosystème
              <strong> Mediiq</strong> — un système de récompense innovant qui relie
              le monde de la santé et celui de la blockchain.
              <br />
              Vérifié et disponible sur la <strong>Binance Smart Chain</strong>,
              chaque transaction est transparente, sécurisée et traçable.
            </p>

            {/* Features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              <div className="flex items-center gap-3 p-4 bg-green-50 rounded-xl shadow hover:shadow-lg transition">
                {/* @ts-ignore */}
                <FaHospital className="text-yellow-500 text-2xl" />
                <p className="text-gray-700 font-semibold">
                  Accumulez des <strong>LVC</strong> à chaque achat de médicaments et de produits de bien-être.
                </p>
              </div>

              <div className="flex items-center gap-3 p-4 bg-green-50 rounded-xl shadow hover:shadow-lg transition">
                {/* @ts-ignore */}
                <FaGift className="text-yellow-500 text-2xl" />
                <p className="text-gray-700 font-semibold">
                  Échangez vos LVC contre des <strong>réductions exclusives</strong> et offres spéciales.
                </p>
              </div>

              <div className="flex items-center gap-3 p-4 bg-green-50 rounded-xl shadow hover:shadow-lg transition">
                {/* @ts-ignore */}
                <FaMoneyBillWave className="text-yellow-500 text-2xl" />
                <p className="text-gray-700 font-semibold">
                  <strong>Mediiq rachète aussi vos LVC</strong> et vous permet de les convertir
                  en <strong>monnaie locale</strong> directement depuis votre profil.
                </p>
              </div>

              <div className="flex items-center gap-3 p-4 bg-green-50 rounded-xl shadow hover:shadow-lg transition">
                {/* @ts-ignore */}
                <FaLink className="text-yellow-500 text-2xl" />
                <p className="text-gray-700 font-semibold">
                  Token vérifié sur la blockchain :{" "}
                  <a
                    href="https://bscscan.com/token/0xf9F39f7e0e99dd50A7Eb506D4732CD53e211c9b3"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline hover:text-blue-800"
                  >
                    Voir sur BscScan
                  </a>
                </p>
              </div>
            </div>

            {/* CTA Section */}
            <div className="flex flex-col items-center mt-8 space-y-3">
              <button
                onClick={() => window.open('https://www.lvcpay.app/whitepaper', '_blank')}
                className="px-8 py-3 bg-yellow-400 text-green-900 font-bold rounded-full shadow-lg hover:bg-yellow-300 transition transform hover:scale-105"
              >
                Découvrir LVC
              </button>
              <p className="text-sm text-gray-600 italic">
                En savoir plus sur l’utilité, la valeur et la vision du token LVC.
              </p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LVCModal;
